import './services.scss';

import { services } from '../../../content';

export const Services = () => {
  return (
    <section className="container" id="benefits">
      <div className="row row-cols-1 row-cols-lg-3">
        {services.map((service, index) => (
          <div
            key={service.id}
            className={`col services-item${index < services.length - 1 ? ' services-item--bordered' : ''}`}
          >
            <div className="text-center">
              <img src={service.icon} alt={service.alt} width="70" className="d-block services-icon mx-auto" />
              <h5 className="services-title">{service.title}</h5>
              <p className="services-description">{service.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
